import {
  CUSTOMER_SERVICE_PHONE_NUMBER,
  SALES_PHONE_NUMBER,
} from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import type { PhoneNumber, SitesAll } from 'src/shared/types';

import translations from '../../.vocab';

interface Props {
  site: SitesAll;
}

export const AdditionalInfo = ({ site }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Box>
      <Stack space="medium">
        <Text weight="strong">
          {t('Customer Service')}:{' '}
          <TextLink
            href={`tel:${(CUSTOMER_SERVICE_PHONE_NUMBER as PhoneNumber)[site]}`}
            tracking={TRACKING_CODES.cs_phone_link_clicked}
          >
            {(CUSTOMER_SERVICE_PHONE_NUMBER as PhoneNumber)[site]}
          </TextLink>
        </Text>
        <Text weight="strong">
          Sales:{' '}
          <TextLink
            href={`tel:${(SALES_PHONE_NUMBER as PhoneNumber)[site]}`}
            tracking={TRACKING_CODES.sales_phone_link_clicked}
          >
            {(SALES_PHONE_NUMBER as PhoneNumber)[site]}
          </TextLink>
        </Text>
      </Stack>
    </Box>
  );
};
